import { mockAdapterData, mockChannelData, mockCurrencyData } from "@/entities";
import { UserClientSubclientServicepoint } from "./servicepoint";
import {
  IUserClientSubclientServicepoint,
  IUserClientSubclientServicepointData,
} from "./servicepoint.types";

export const mockUserClientSubclientServicepointData =
  (): IUserClientSubclientServicepointData[] => [
    {
      id: 2,
      oidSol: "f6282ebb-60e7-4332-bf88-e2653da2e2e2",
      codeSol: "0087",
      idSmartcash: "0087",
      uniqueCode: "",
      deviceId: "000005008787",
      description: "Rio - Suc. 087 Centro-0",
      address: "San Martin 427 0, Capital Federal - 1",
      openChannel: true,
      accountDate: true,
      active: true,
      adapters: mockAdapterData(),
      channels: mockChannelData(),
      currencies: mockCurrencyData(),
      agilePickup: false,
      econoCash: false,
      flowApproval: false,
    },
    {
      id: 6,
      oidSol: "8d0f9115-0ec3-11e9-baf6-bf8497b63b21",
      codeSol: "EDETAS1",
      idSmartcash: "72",
      uniqueCode: "",
      deviceId: "008944001372",
      description: "E.D.E.T. - Avellaneda",
      address: "Amadeo Jaques 40 0, San Miguel de Tucuman - 23",
      openChannel: true,
      accountDate: false,
      active: true,
      adapters: mockAdapterData(),
      channels: mockChannelData(),
      currencies: mockCurrencyData(),
      agilePickup: false,
      econoCash: false,
      flowApproval: false,
    },
  ];

export const mockUserClientSubclientServicepoint = (
  data: IUserClientSubclientServicepointData[] = mockUserClientSubclientServicepointData()
): IUserClientSubclientServicepoint[] =>
  data.map((item) => new UserClientSubclientServicepoint(item));
